import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { SubTypeOption } from "../../api/gms/group-category/group-category-api-state";

interface ProposalStatusResponse {
    status_id: number;
    status_name: string;
}


interface TypeState {
    selectedProposalId: number | null;
    selectedPendingEmail: string | null;
    proposalPreparedBy : SubTypeOption | null;
    proposalStatus : SubTypeOption | null;
    selectProposalExtensionSECName: string | null;
    selectProposalExtensionPreparedBy: string | null;
    actuarialStatus: ProposalStatusResponse[];
    ebamStatus: ProposalStatusResponse[];
}

const initialState: TypeState = {
    selectedProposalId: null,
    proposalPreparedBy: null,
    proposalStatus: null,
    selectedPendingEmail: null,
    selectProposalExtensionSECName: null,
    selectProposalExtensionPreparedBy: null,
    actuarialStatus: [],
    ebamStatus: []
};

const stateSlice = createSlice({
    name: "state",
    initialState,
    reducers: {
        setUpdateStatus: (state, action: PayloadAction<{type: 'ebam' | 'actuarial', value: ProposalStatusResponse[]}>) => {
            const { type, value } = action.payload;
            if(type === 'actuarial') {
                state.actuarialStatus = value;
            }
            if(type === 'ebam') {
                state.ebamStatus = value;
            }
        },
        setSelectedProposalId: (state, action: PayloadAction<number>) => {
            state.selectedProposalId = action.payload;
        },
        clearSelectedProposalId: (state) => {
            state.selectedProposalId = null
        },
        setSelectedPendingEmail: (state, action: PayloadAction<string>) => {
            state.selectedPendingEmail = action.payload;
        },
        clearSelectedPendingEmail: (state) => {
            state.selectedPendingEmail = null
        },

        setProposalPreparedBy: (state, action: PayloadAction<SubTypeOption>) => {
            state.proposalPreparedBy = action.payload;
        },
        clearProposalPreparedBy: (state) => {
            state.proposalPreparedBy = null
        },

        setProposalStatus: (state, action: PayloadAction<SubTypeOption>) => {
            state.proposalStatus = action.payload;
        },
        clearProposalStatus: (state) => {
            state.proposalStatus = null
        },
        
        setProposalExtension: (state, action: PayloadAction<{ type: 'sec' | 'prep', value: string }>) => {
            const { type, value } = action.payload
            if(type === 'prep'){
                state.selectProposalExtensionPreparedBy = value;
            }
            if(type === 'sec'){
                state.selectProposalExtensionSECName = value;
            }
        },
        setClearProposalExtension: (state) => {
            state.selectProposalExtensionPreparedBy = null
            state.selectProposalExtensionSECName = null
        }
    },
});

export const { 
    setUpdateStatus,

    setSelectedProposalId,
    clearSelectedProposalId,
    setSelectedPendingEmail,
    clearSelectedPendingEmail,

    setProposalPreparedBy,
    clearProposalPreparedBy,

    setProposalStatus,
    clearProposalStatus,

    setProposalExtension,
    setClearProposalExtension
} = stateSlice.actions;

export const selectedProposalId = (state: RootState) => state.state.selectedProposalId

export const selectedPendingEmail = (state: RootState) => state.state.selectedPendingEmail

export const selectedProposalPreparedBy = (state: RootState) => state.state.proposalPreparedBy
export const selectedProposalPreparedById = (state: RootState) => state.state.proposalPreparedBy?.id
export const selectedProposalPreparedByName = (state: RootState) => state.state.proposalPreparedBy?.name

export const selectedActuarialStatus = (state: RootState) => state.state.actuarialStatus;
export const selectedEbamStatus = (state: RootState) => state.state.ebamStatus;

export const selectedCurrentProposalStatus = (state: RootState) => state.state.proposalStatus
export const selectedCurrentProposalStatusName = (state: RootState) => state.state.proposalStatus?.name
export const selectedCurrentProposalStatusId = (state: RootState) => state.state.proposalStatus?.id

export const selectedProposalExtensionSECName = (state: RootState) => state.state.selectProposalExtensionSECName

export const selectedProposalExtensionPreparedBy = (state: RootState) => state.state.selectProposalExtensionPreparedBy

export default stateSlice.reducer;
